

import { Button, CssBaseline, Grid } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import { withRouter } from 'react-router-dom';
import { ReCAPTCHAConfig } from '../../../../config/app';
import { DataApi } from '../../../../providers/api-provider';
import { formatCurrency, postMessageToParent, track } from '../../libs/helpers';
import FundraiseSharer from '../fundraise-seed/FundraiseSharer';
import styles from '../styles/campaign-seed';
import GeneralSeedForm from './GeneralSeedForm';


class GeneralSeed extends React.Component {
  constructor(props) {
    super(props);
    this.trackPageCode = 'General Donation'
    track(this.trackPageCode, 'Checkout Opened', '', true);
  }
  state = {
    dataLoading: false,
    loading: false,
    done: false,
    recaptchaEnabled: 0,
    recaptcha: '',
    processedAmount: ''
  }
  recaptchaRef = React.createRef()

  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
 */
  fetchRecaptchaStateData = async () => {
    try {
      let res = await DataApi.getOne('recaptcha');
      this.setState({ recaptchaEnabled: res.data });
    } catch (e) {
      this.setState({ recaptchaEnabled: true });
    }
  }
  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */

  async componentDidMount() {
    this.fetchRecaptchaStateData();
  }
  performPostSeedAction = async () => {
    postMessageToParent('hide_modal');
  }
  onDonationComplete = (processedAmount) => {
    this.setState({ done: true, processedAmount })
  }

  onGoBackClicked() {
    postMessageToParent('hide_modal');
  }
  renderForm(classes) {
    const { loading, recaptcha, recaptchaEnabled } = this.state;
    let { trackPageCode, recaptchaRef, onDonationComplete } = this;

    return <GeneralSeedForm {...{
      classes, loading, trackPageCode, recaptcha, recaptchaRef,
      onDonationComplete, recaptchaEnabled
    }} />
  }
  renderContainer(dataLoading, classes) {
    return this.renderForm(classes);
  }
  renderDone = () => {
    const { processedAmount, form, loading } = this.state;
    const { classes } = this.props;
    return (<div className={classes.doneContainer}>
      <Grid container justify="space-between">
        <Grid item xs={9}>
          <Typography variant="h4" className={classes.doneHeader}>
            THANK YOU!
          </Typography>
          <Typography variant="body1" className={classes.doneSubheader}>
            for your generous donation of <span style={{ fontWeight: 700, color: '#6A6A6A' }}>${formatCurrency(processedAmount)}</span><br />
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <img className={'fullwidth'} src={require('../../../../images/post-donation.svg')} />
        </Grid>
      </Grid>
      <div>
        <Button fullWidth onClick={this.performPostSeedAction} variant={"contained"} className={classes.postSeedButton}>
          Continue browsing
        </Button>
        <FundraiseSharer classes={classes} />
      </div>
    </div>);
  }
  /* Render Page */
  render() {
    const { classes } = this.props;
    const { recaptchaEnabled, dataLoading, done } = this.state;
    return (
      <main className={[classes.main]}>
        <CssBaseline />
        <Paper className={classes.paper + ' seed-page-paper'} style={{ backgroundColor: '#fffffff1' }}>

          <div className={done ? 'd-none' : 'fullwidth'}>
            {this.renderContainer(dataLoading, classes)}
          </div>
          {done && this.renderDone()}
          {recaptchaEnabled!== 0 &&
            <ReCAPTCHA
              sitekey={ReCAPTCHAConfig.site_key_invisible}
              size="invisible"
              ref={this.recaptchaRef}
            />
          }
        </Paper>
      </main>
    );
  }
}

GeneralSeed.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(withRouter(GeneralSeed));
